import React from 'react'
import TopNavbar from '../Nav/TopNavbar'

import Footer from '../Sections/Footer'
import FirstPeriodDesc from '../Sections/FirstPeriodDesc'

function FirstPeriodPage() {
    return (
      <>
          <TopNavbar/>
          <FirstPeriodDesc/>
          <Footer/>
      </>
    )
}

export default FirstPeriodPage